import 'firebase/compat/firestore';
import { Album } from "../models/Albums";

import 'firebase/compat/firestore';
import firebase from "firebase/compat/app";
import { fetchVisibleCollection } from "./PlaylistService";
import { getViewer, viewerCollectionTier } from "./Viewer";
const firestore = firebase.firestore

export class AlbumsService {
  static StronglyTypeAlbumData = (
    albumDoc:
      | firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData>
      | firebase.firestore.DocumentSnapshot<firebase.firestore.DocumentData>
  ) => {
    return { ...albumDoc.data(), id: albumDoc.id } as Album;
  };

  static transmit = (freshAlbum: Album) => {
    const db = firestore();
    // Always explicit: the rules require a boolean isPrivate on create.
    return db.collection("albums").doc(freshAlbum.id).set({ ...freshAlbum, isPrivate: !!freshAlbum.isPrivate, privacy: viewerCollectionTier() });
  };

  static fetchAll = () => {
    return new Promise<Album[]>((resolve, reject) => {
      fetchVisibleCollection("albums")
        .then((albumDocs) => {
          const allAlbums = albumDocs.map((albumDoc) => {
            return AlbumsService.StronglyTypeAlbumData(albumDoc);
          });
          resolve(allAlbums);
        })
        .catch(reject);
    });
  };

  static fetch = (id: string) => {
    return new Promise<Album>((resolve, reject) => {
      const db = firestore();
      db.collection("albums")
        .doc(id)
        .get()
        .then((albumDoc) => {
          const album = AlbumsService.StronglyTypeAlbumData(albumDoc);
          resolve(album);
        })
        .catch(reject);
    });
  };

  static delete = (id: string): Promise<void> => {
    return new Promise<void>((resolve) => {
      const db = firestore();
      if (!id || id === "") {
        return;
      }
      db.collection("albums")
        .doc(id)
        .delete()
        .then(() => {
          resolve();
        });
    });
  };

  static update = (album: Album): Promise<Album> => {
    return new Promise<Album>((resolve, reject) => {
      const db = firestore();
      const serverAlbum = db.collection("albums").doc(album.id);
      // The owner's edits re-stamp the audience tier from their current profile.
      const own = album.ownerId === getViewer().uid;
      serverAlbum.set(own ? { ...album, privacy: viewerCollectionTier() } : album, { merge: true }).then(() => {
        serverAlbum
          .get()
          .then((albumDoc) => {
            const album = AlbumsService.StronglyTypeAlbumData(albumDoc);
            resolve(album);
          })
          .catch(reject);
      });
    });
  };
}
